import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      
      // Mostrar después de 5 segundos
      setTimeout(() => {
        const dismissed = localStorage.getItem('nexia-install-dismissed');
        if (!dismissed) {
          setShowPrompt(true);
        }
      }, 5000);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    if (outcome === 'accepted') {

    }
    
    setDeferredPrompt(null);
    setShowPrompt(false);
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    localStorage.setItem('nexia-install-dismissed', 'true');
  };

  if (!showPrompt) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 100, opacity: 0 }}
        className="fixed bottom-20 md:bottom-6 left-6 right-6 md:left-auto md:right-6 md:w-96 z-50"
      >
        <div className="decko-card p-5 border-2 border-primary/30" style={{
          background: 'linear-gradient(135deg, rgba(0,208,132,0.05) 0%, #FFFFFF 100%)',
          boxShadow: '0 20px 40px rgba(0,0,0,0.15)'
        }}>
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary to-accent flex items-center justify-center flex-shrink-0">
              <span className="text-2xl">📱</span>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-foreground mb-1">Instalar Nexia</h3>
              <p className="text-xs text-muted-foreground mb-3">
                Accede más rápido desde tu pantalla de inicio
              </p>
              <div className="flex gap-2">
                <button
                  onClick={handleInstall}
                  className="btn-primary text-xs px-4 py-2"
                >
                  Instalar
                </button>
                <button
                  onClick={handleDismiss}
                  className="btn-secondary text-xs px-4 py-2"
                >
                  Ahora no
                </button>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default InstallPrompt;
